export default __webpack_public_path__ + "static/media/Covid_19_India.d61b2131.avif";